module.exports = __webpack_public_path__ + "gp.svg?b1feb2ba7f7335aacabda4fbc0ce012d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gp.svg
// module id = 1262
// module chunks = 27